
import {Component, Prop, Vue} from "vue-property-decorator";

// #268 リニューアルページ共通のページ末尾CTA帯
// lead: リード文(複雑な内容はslot#leadで差し替え可) / defaultスロットにボタンを並べる
@Component
export default class CtaSection extends Vue {
  @Prop({type: String, required: false, default: ""})
  lead!: string;
}
